import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import _regeneratorRuntime from "/vercel/path1/node_modules/next/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/vercel/path1/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { Box, Button, Heading, Stack, Text } from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import { Card } from './Card';
import { Link } from './Link';
import { LoginForm } from './LoginForm';
import NextLink from 'next/link';
import { useRouter } from 'next/dist/client/router';
import { useUser } from '../../../providers/useUser';
export var Authentication = function Authentication(props) {
  var _useUser = useUser(),
      signIn = _useUser.signIn,
      signUp = _useUser.signUp;

  var router = useRouter();

  var _useState = useState(null),
      error = _useState[0],
      setError = _useState[1];

  var _useState2 = useState(null),
      message = _useState2[0],
      setMessage = _useState2[1];

  var _useState3 = useState(false),
      isLoading = _useState3[0],
      setIsLoading = _useState3[1];

  var _useUser2 = useUser(),
      user = _useUser2.user,
      session = _useUser2.session,
      signOut = _useUser2.signOut;

  useEffect(function () {
    if (session) {
      fetch('/api/auth', {
        method: 'POST',
        headers: new Headers({
          'Content-Type': 'application/json'
        }),
        credentials: 'same-origin',
        body: JSON.stringify({
          event: event,
          session: session
        })
      }).then(function () {
        var _router$query;

        if ((_router$query = router.query) !== null && _router$query !== void 0 && _router$query.next) {
          console.log('NEXT!!! 000');
          router.push(router.query.next);
        }
      });
    }
  }, [session]);

  var handleSigninSubmit = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(params) {
      var _yield$signIn, error, _ref2;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setIsLoading(true);
              setError(null);
              setMessage(null);
              _context.next = 5;
              return signIn(params);

            case 5:
              _yield$signIn = _context.sent;
              error = _yield$signIn.error;
              if (error) setError(error.message);else if (!params.password) {
                // it's magic link
                setMessage('Check your email for your magic link.');
              } else {
                router.push((_ref2 = router.query.next) !== null && _ref2 !== void 0 ? _ref2 : '/account');
              }
              setIsLoading(false);

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleSigninSubmit(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  var handleSignupSubmit = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(params) {
      var _yield$signUp, error;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              setIsLoading(true);
              setError(null);
              setMessage(null);
              _context2.next = 5;
              return signUp(params);

            case 5:
              _yield$signUp = _context2.sent;
              error = _yield$signUp.error;
              if (error) setError(error.message);else {
                setMessage('Check your email for verification.');
              }
              setIsLoading(false);

            case 9:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleSignupSubmit(_x2) {
      return _ref3.apply(this, arguments);
    };
  }();

  if (session) {
    return /*#__PURE__*/_jsx(Card, {
      children: /*#__PURE__*/_jsxs(Stack, {
        spacing: 5,
        children: [/*#__PURE__*/_jsxs(Text, {
          children: ["Authenticated as", ' ', /*#__PURE__*/_jsx(Text, {
            as: "span",
            fontWeight: "bold",
            children: user === null || user === void 0 ? void 0 : user.email
          })]
        }), /*#__PURE__*/_jsxs(Stack, {
          children: [/*#__PURE__*/_jsx(NextLink, {
            href: "/account",
            passHref: true,
            children: /*#__PURE__*/_jsx(Button, {
              children: "Go to account"
            })
          }), /*#__PURE__*/_jsx(Button, {
            colorScheme: "red",
            onClick: signOut,
            children: "Sign out"
          })]
        })]
      })
    });
  }

  return /*#__PURE__*/_jsxs(Box, {
    children: [/*#__PURE__*/_jsx(Heading, {
      size: "xl",
      fontWeight: "extrabold",
      children: props.isSignup ? 'Create an account' : 'Sign in to your account'
    }), /*#__PURE__*/_jsx(Text, {
      mt: "4",
      mb: "8",
      maxW: "md",
      fontWeight: "medium",
      children: props.isSignup ? /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(Text, {
          as: "span",
          children: 'Already have an account?'
        }), /*#__PURE__*/_jsx(Link, {
          children: /*#__PURE__*/_jsx(NextLink, {
            href: "/signin",
            children: "Sign in"
          })
        })]
      }) : /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(Text, {
          as: "span",
          children: "Don't have an account?"
        }), /*#__PURE__*/_jsx(Link, {
          children: /*#__PURE__*/_jsx(NextLink, {
            href: "/signup",
            children: "Sign up"
          })
        })]
      })
    }), /*#__PURE__*/_jsxs(Card, {
      children: [!!error && /*#__PURE__*/_jsx(Text, {
        mb: "5",
        color: "red.500",
        children: error
      }), !!message ? /*#__PURE__*/_jsx(Text, {
        mb: "5",
        fontSize: "lg",
        children: message
      }) : props.isSignup ? /*#__PURE__*/_jsx(LoginForm, {
        onSubmit: handleSignupSubmit,
        collectName: true,
        label: "Sign up",
        isLoading: isLoading
      }) : /*#__PURE__*/_jsx(LoginForm, {
        onSubmit: handleSigninSubmit,
        isLoading: isLoading,
        allowMagic: true
      }), /*#__PURE__*/_jsxs(Text, {
        mt: "3",
        children: ['By continuing you agree to our', /*#__PURE__*/_jsx(Link, {
          href: "/terms",
          children: "terms of service"
        }), " and acknowledge our", /*#__PURE__*/_jsx(Link, {
          href: "/privacy",
          children: "privacy policy"
        })]
      })]
    })]
  });
};
export default Authentication;